var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item m-0 py-0 w-100"},[_c('router-link',{class:_vm.linkClass,attrs:{"tag":"a","to":{name: _vm.page.name}}},[_vm._v("\n    "+_vm._s(_vm.linkTitle)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }